// components/Notification.js
import { useEffect } from "react";
import { notification } from "antd";
import { connect } from "react-redux";
import { hideNotification } from "store/slices/notificationSlice";

const Notification = ({ notifications, hideNotification }) => {
  useEffect(() => {
    if (notifications.visible) {
      if (notifications.type === "success")
        notification.success({
          message: notifications.message,
          description: notifications.description,
          onClose: hideNotification,
        });
      else
        notification.error({
          message: notifications.message,
          description: notifications.description,
          onClose: hideNotification,
        });
    }
  });

  return null; // This component does not render anything itself
};

const mapStateToProps = (state) => ({
  notifications: state.notification,
});

const mapDispatchToProps = {
  hideNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
